// extracted by mini-css-extract-plugin
export default {"slideShowIconContainer":"wwzV1R","slideShowIconBackground":"qh42TZ"};